// TODO: Move this to core funcitonaility of the Tablke component
import {
  Button,
  Icon,
  SmartTableColumn,
  Tooltip,
  TooltipTrigger,
} from '@design';
import { CheckBox } from '@design/components/checkbox/CheckBox';
import { Dropdown } from '@design/components/dropdown/Dropdown';
import { Input } from '@design/components/input/Input';
import { TableHeader } from '@design/components/table/table-header/TableHeader';
import React, { useState } from 'react';

import styles from './TableColumnsEditor.module.scss';

export interface TableColumnsEditorTranslations {
  editColumnTooltip: string;
}

export interface TableColumnsEditorProps<T> {
  columns: SmartTableColumn<T>[];
  activeColumnKeys: string[];
  onActiveColumnToggle: (
    name: Extract<keyof T, string>,
    isChecked: boolean
  ) => void;
  i18nTranslations: {
    editColumnTooltip: string;
  };
}

export function TableColumnsEditor<T>({
  columns,
  activeColumnKeys,
  onActiveColumnToggle,
  i18nTranslations,
}: Readonly<TableColumnsEditorProps<T>>) {
  const [searchValue, setSearchValue] = useState('');

  const hidableColumns = columns.filter(column => !column.disableHiding);
  const filteredColumns = searchValue
    ? hidableColumns.filter(column =>
        column.label
          .toLocaleLowerCase()
          .includes(searchValue.toLocaleLowerCase())
      )
    : hidableColumns;

  return (
    <TableHeader
      className={styles.addColumnTableHeader}
      data-add-column-table-header
      isSorted
      alignment="end"
    >
      <Dropdown
        className={styles.columnsDropdown}
        inPortal
        beforeResultsNode={
          <Input
            className={styles.searchInput}
            data-testid="search-input"
            size="medium"
            leftIcon={<Icon iconName={'Search'} size={18} />}
            onChange={e => setSearchValue(e.target.value)}
          />
        }
        placement="bottom-end"
        onItemsShowChange={() => setSearchValue('')}
        dropdownItems={filteredColumns}
        shouldCloseOnSelect={false}
        shouldShowItems={false}
        renderDropdownItem={item => (
          <div
            className={styles.itemRow}
            key={item.key}
            data-testid="dropdown-item"
          >
            <CheckBox
              className={styles.dropdownCheckbox}
              data-testid="column-checkbox"
              name={item.key}
              label={item.label}
              checked={activeColumnKeys.includes(item.key)}
              onChange={() =>
                onActiveColumnToggle(
                  item.key,
                  !activeColumnKeys.includes(item.key)
                )
              }
              size="small"
            />
          </div>
        )}
      >
        <div>
          <Tooltip
            isTouchDevice={false}
            trigger={TooltipTrigger.Hover}
            label={i18nTranslations.editColumnTooltip}
            inPortal
          >
            <Button
              data-testid="open-dropdown-btn"
              iconName="Pencil"
              variant="secondary"
              size="xsmall"
            />
          </Tooltip>
        </div>
      </Dropdown>
    </TableHeader>
  );
}
